import React, { useState } from "react";
import "./ManageServicesList.css";
import Widgets from "../../../../widgets";
import plusIcon from "../../../../Assets/Icons/PlusIcon.png";
import Icons from "../../../../Assets/Icons";
import { useTranslation } from "react-i18next";
import MRList from "./MRList";
import ServiceGroupList from "./ServiceGroupList";
import SubServiceGroupList from "./SubServiceGroupList";
import strings from "../../../../utils/strings";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchServiceItems, fetchServices } from "../../../../modules/NursignCare/ManageServices/ManageServiceThunk";
import { useDispatch } from "react-redux";
import { bulkUploadServiceItems } from "../../../../modules/NursignCare/ManageServices/ManageServiceThunk";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import BulkUploadInfoModal from "../../../../widgets/BulkUploadInfoModal/BulkUploadInfoModal";

const ManageServicesList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const path = location.pathname;
  let activeTab = "serviceItem";
  let headingKey = "manageServiceItem";

  if (path.includes("sub-group")) {
    activeTab = "subServiceGroup";
    headingKey = "manageSubServiceGroup";
  } else if (path.includes("group")) {
    activeTab = "serviceGroup";
    headingKey = "manageServiceGroup";
  }

  const breadcrumbs = ["nursingCare", "manageService", headingKey];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService, path];

  const [searchValue, setSearchValue] = useState("");
  const [entrySummary, setEntrySummary] = useState({ displayed: 0, total: 0 });
  const [showBulkInfo, setShowBulkInfo] = useState(false);
  const [bulkResult, setBulkResult] = useState({ success: 0, duplicate: 0, fail: 0, createdGroup: 0 });

  const handleFileUpload = async (file) => {
    if (!file) return;
    ToastPopup.info(t("bulkUploadStarted"));
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await dispatch(bulkUploadServiceItems(formData)).unwrap();

      let success = 0, fail = 0;

      if (response?.data?.created) {
        success = (response.data.created.services || 0) + (response.data.created.subServices || 0) + (response.data.created.serviceItems || 0);
      }

      if (response?.data?.skipped) {
        fail = (response.data.skipped.serviceItems?.length || 0);
      }

      setBulkResult({ success, duplicate: fail, fail: 0, createdGroup: 0 });
      setShowBulkInfo(false);
      ToastPopup.success(t("bulkUploadCompleted"));
      dispatch(fetchServices({ page: 1, limit: 10 }));
    } catch (error) {
      setShowBulkInfo(false);
      ToastPopup.error(typeof error === "string" ? error : error?.message || t("bulkUploadFailed"));
    }
  };

  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="manage-service-heading">{t(headingKey) || "Manage Service"}</div>

      <div className="manage-service-search-line" style={{ marginTop: "2rem" }}>
        <Widgets.SearchBox placeholder={"searchByServiceGroup"}
          value={searchValue}
          onSearch={(value) => setSearchValue(value)}
        />
        <div className="manage-service-action-group">
          <Widgets.IconButton iconSrc={Icons.publish} buttonText="BulkUpload" onClick={() => setShowBulkInfo(true)} />
          <Widgets.IconButton iconSrc={plusIcon} buttonText="addService" onClick={() => navigate(strings.navigation.createService)} />
        </div>
      </div>
      <div className="manage-service-entry-summary">
        {t("Showing")} {entrySummary.displayed} {t("entriesOf")} {entrySummary.total} {t("total")}
      </div>
      <div className="mr-list-box">
        {activeTab === "serviceGroup" && (
          <ServiceGroupList searchValue={searchValue} onEntrySummaryChange={setEntrySummary} />
        )}
        {activeTab === "subServiceGroup" && (
          <SubServiceGroupList searchValue={searchValue} onEntrySummaryChange={setEntrySummary} />
        )}
        {activeTab === "serviceItem" && (
          <MRList searchValue={searchValue} onEntrySummaryChange={setEntrySummary} />
        )}
      </div>
      <BulkUploadInfoModal
        showModal={showBulkInfo}
        onClose={() => setShowBulkInfo(false)}
        onUpload={handleFileUpload}
        sampleFileUrl={`${process.env.PUBLIC_URL}/sample_service_bulk_upload.xlsx`}
      />
    </div>
  );
};

export default ManageServicesList;
